import {
  AppointmentResponse,
  HealthieTag,
} from '@web-app/hooks/queries/appointment-by-room-name/types';

/**
 * Tags for the appointment's patient. The Healthie payload is authoritative but
 * can arrive tagless, so an empty list falls back to the Berry Street record.
 */
export const getAppointmentTags = (
  appointment?: AppointmentResponse,
): HealthieTag[] => {
  const healthieTags = appointment?.healthie?.user?.tags;
  return healthieTags?.length ? healthieTags : (appointment?.user?.tags ?? []);
};

export const hasPatientTag = (
  tags: HealthieTag[] | undefined,
  tagName: string,
): boolean => {
  if (!Array.isArray(tags) || tags.length === 0) {
    return false;
  }

  const normalizedTagName = tagName.toLowerCase();
  return tags.some((tag) => tag.name?.toLowerCase() === normalizedTagName);
};

/** Exact, case-sensitive matching for server-controlled eligibility tags. */
export const hasExactPatientTag = (
  tags: HealthieTag[] | undefined,
  tagName: string,
): boolean => tags?.some((tag) => tag.name === tagName) ?? false;

export const getPatientFirstName = (fullName?: string | null): string => {
  const firstName = fullName?.trim().split(/\s+/)[0];
  return firstName || 'this patient';
};
